import { SoakingSampleTest } from "../entities/soaking-sample-test.entity";
import { SoakingSampleTestDTO } from "./soaking-sample-test.dto";

export class SoakingSampleTestAdapter {
    public convertDtoToEntity(dto: SoakingSampleTestDTO,isUpdate: boolean = false):SoakingSampleTest{
        const entity = new SoakingSampleTest;
        entity.soakingSampleTestId = dto.soakingSampleTestId
        entity.logId = dto.logId
        entity.jobNumber = dto.jobNumber
        entity.batchNoScode = dto.batchNoScode
        entity.bsTemp = dto.bsTemp
        entity.bsWeight = dto.bsWeight
        entity.bsCount = dto.bsCount
        entity.asCount = dto.asCount
        entity.asTemp = dto.asTemp
        entity.asWeight = dto.asWeight
        entity.chemicalConsumptionb = dto.chemicalConsumptionb
        entity.chemicalConsumptiona = dto.chemicalConsumptiona
        entity.timeIn = dto.timeIn
        entity.timeOut = dto.timeOut
        entity.pickupPercentage = dto.pickupPercentage
        entity.remarks = dto.remarks
        if(dto.soakingSampleTestId){
            entity.soakingSampleTestId = dto.soakingSampleTestId;
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.createdUser = dto.createdUser;
        }
        return entity;

        
}

        public convertEntityToDto(obj: SoakingSampleTest) : SoakingSampleTestDTO {
            const dto= new SoakingSampleTestDTO;
        dto.soakingSampleTestId = obj.soakingSampleTestId;
        dto.logId = obj.logId;
        dto.jobNumber = obj.jobNumber;
        dto.batchNoScode = obj.batchNoScode;
        dto.bsTemp = obj.bsTemp;
        dto.bsWeight = obj.bsWeight;
        dto.bsCount = obj.bsCount;
        dto.asCount = obj.asCount;
        dto.asTemp = obj.asTemp;
        dto.asWeight = obj.asWeight;
        dto.chemicalConsumptionb = obj.chemicalConsumptionb;
        dto.chemicalConsumptiona = obj.chemicalConsumptiona;
        dto.timeIn = obj.timeIn;
        dto.timeOut = obj.timeOut;
        dto.pickupPercentage = obj.pickupPercentage;
        dto.remarks = obj.remarks;
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        return dto; 
        }

}